import React, { memo } from 'react';

const UserSettingsScreen = memo(() => {
  return <div></div>;
});

UserSettingsScreen.displayName = 'UserSettingsScreen';

export { UserSettingsScreen };
